export default {
  en: {
    reimport: 'Import again',
    deleteImport: 'Delete import record',
    deleteProducts: 'Delete imported products',
    cleanupImport: 'Clean up remaining categories and images',
    cleanupImportConfirm: 'Remove empty categories created by this import and try deleting its unused image files? Shared categories and images will remain.',
    deleteImportConfirm: 'Remove this import from history? Products already created in the catalog will remain.',
    deleteProductsConfirm: 'Delete the products created by this import and their options? Empty categories created by this import and unused import images will also be removed. Shared categories and images will remain.',
    productsDeleted: 'The imported products have been deleted. You can import the store again to create a fresh preview.',
    statusProductsDeleted: 'Products deleted',
    warnings: {
      DEFAULT_MODIFIER_PRICE_SEPARATED: 'The displayed price includes selected modifiers. Their total ({amount}) was separated from the base price; review this calculation.',
      INDIVIDUAL_LIMITS_ABSENT: 'Glovo provides selection limits for groups, but no individual quantity limits. Review these before importing.',
      MISSING_TAX_AND_POS_MAPPING: 'Review the VAT and POS mappings. Platform identifiers are not local POS IDs.',
      ADDITIONAL_SOURCE_DETAILS: 'Promotions, schedules, nutrition, restrictions and other platform-specific fields remain in the source details when no catalog mapping exists. Base prices are imported.',
      PRODUCT_DEPOSIT_AS_REQUIRED_GROUP: 'This product deposit is imported as a required SGR option group. Its amount is preserved.',
      IMAGE_DOWNLOAD_FAILED: 'Some images could not be downloaded.',
      DEPOSIT_FROM_FEE_LABEL: 'Review the attached deposit identified from the SGR fee label: {label}',
      FEE_REQUIRES_REVIEW: 'Set the attached deposit based on the source fee label: {label}',
      UNSUPPORTED_OPTION_PRICING_OR_DEPENDENCY: 'Conditional prices or free-choice pricing require manual adjustment.'
    },
    storeUrlRequired: 'Enter the store URL.',
    storeUrlInvalid: 'Enter a valid store URL, for example https://glovoapp.com/ro/ro/sibiu/stores/mos-burger.',
    platform: 'Platform',
    date: 'Created',
    status: 'Status',
    open: 'Open',
    noHistory: 'No menu imports yet.',
    statusProcessing: 'Processing',
    statusReady: 'Ready to review',
    statusConfirming: 'Importing',
    statusConfirmed: 'Completed',
    statusFailed: 'Failed',
    statusCanceled: 'Canceled',
    menuPreview: 'Menu preview',
    editDetails: 'Edit details',
    view: 'Preview view',
    storeUrl: 'Store URL',
    loading: 'Loading preview…',
    noResults: 'No selected products match your search.',
    acknowledgeHint: 'Review the data gaps above, then check the acknowledgement to enable import.',
    apiUnavailable: 'The menu import API is not available on this server. Deploy the API update and run its migration.',
    accessDenied: 'Your account does not have permission to import menus for this company.',
    timedOut: 'The import request timed out. Check import history before retrying.',
    title: 'Import menu from platform',
    back: 'Back',
    intro: 'Paste a Glovo, Wolt or Bolt store URL. Review the menu before adding it to this location. Existing catalog items are unchanged.',
    preview: 'Load preview',
    processing: 'Processing menu… Please keep this page open.',
    done: 'Import completed',
    products: 'products',
    categories: 'Categories',
    gaps: 'Source data gaps and warnings',
    search: 'Search products and options',
    image: 'Image URL (one per line)',
    name: 'Name',
    price: 'Base price',
    description: 'Description',
    available: 'Available',
    tax: 'Location VAT mapping',
    unknown: 'Unknown / not provided',
    mode: 'Selection mode',
    single: 'Single selection',
    multiple: 'Multiple selection',
    counter: 'Repeated quantities',
    groupMin: 'Group minimum',
    groupMax: 'Group maximum',
    eachMin: 'Per-choice minimum',
    eachMax: 'Per-choice maximum',
    default: 'Selected by default',
    source: 'Original source details',
    reviewFee: 'Review and enter this separate fee as a deposit before confirming.',
    addDeposit: 'Add attached SGR deposit',
    acknowledge: 'I reviewed the source gaps, missing tax/POS mappings and export limitations.',
    skipImages: 'Allow importing without images that fail to download.',
    save: 'Save preview',
    confirm: 'Confirm and add new items',
    cancel: 'Cancel import',
    history: 'Platform import history',
    requestFailed: 'Request failed. Check your access or reload the preview if another user edited it.'
  },
  ro: {
    reimport: 'Importă din nou',
    deleteImport: 'Șterge înregistrarea importului',
    deleteProducts: 'Șterge produsele importate',
    cleanupImport: 'Curăță categoriile și imaginile rămase',
    cleanupImportConfirm: 'Ștergi categoriile goale create de acest import și încerci eliminarea imaginilor neutilizate? Categoriile și imaginile partajate vor rămâne.',
    deleteImportConfirm: 'Elimini acest import din istoric? Produsele deja create în catalog vor rămâne.',
    deleteProductsConfirm: 'Ștergi produsele create de acest import și opțiunile lor? Se vor elimina și categoriile goale create de import și imaginile neutilizate ale importului. Categoriile și imaginile partajate vor rămâne.',
    productsDeleted: 'Produsele importate au fost șterse. Poți importa din nou magazinul pentru a crea o previzualizare nouă.',
    statusProductsDeleted: 'Produse șterse',
    warnings: {
      DEFAULT_MODIFIER_PRICE_SEPARATED: 'Prețul afișat include opțiunile selectate implicit. Totalul acestora ({amount}) a fost separat de prețul de bază. Verifică acest calcul.',
      INDIVIDUAL_LIMITS_ABSENT: 'Glovo oferă limite de selecție pentru grupuri, dar nu și limite individuale de cantitate. Verifică-le înainte de import.',
      MISSING_TAX_AND_POS_MAPPING: 'Verifică asocierile TVA și POS. Identificatorii platformei nu sunt ID-uri POS locale.',
      ADDITIONAL_SOURCE_DETAILS: 'Promoțiile, programul, informațiile nutriționale, restricțiile și alte câmpuri specifice platformei rămân în detaliile sursei dacă nu au un câmp echivalent în catalog. Se importă prețurile de bază.',
      PRODUCT_DEPOSIT_AS_REQUIRED_GROUP: 'Garanția acestui produs se importă ca grup obligatoriu de opțiuni SGR. Valoarea acesteia este păstrată.',
      IMAGE_DOWNLOAD_FAILED: 'Unele imagini nu au putut fi descărcate.',
      DEPOSIT_FROM_FEE_LABEL: 'Verifică garanția atașată, identificată din eticheta taxei SGR: {label}',
      FEE_REQUIRES_REVIEW: 'Completează garanția atașată pe baza etichetei taxei din sursă: {label}',
      UNSUPPORTED_OPTION_PRICING_OR_DEPENDENCY: 'Prețurile condiționate sau opțiunile gratuite necesită ajustare manuală.'
    },
    storeUrlRequired: 'Introdu URL-ul magazinului.',
    storeUrlInvalid: 'Introdu un URL valid al magazinului, de exemplu https://glovoapp.com/ro/ro/sibiu/stores/mos-burger.',
    platform: 'Platformă',
    date: 'Data creării',
    status: 'Stare',
    open: 'Deschide',
    noHistory: 'Nu există încă importuri de meniu.',
    statusProcessing: 'Se procesează',
    statusReady: 'Pregătit de verificare',
    statusConfirming: 'Se importă',
    statusConfirmed: 'Finalizat',
    statusFailed: 'Eșuat',
    statusCanceled: 'Anulat',
    menuPreview: 'Previzualizare meniu',
    editDetails: 'Editează detaliile',
    view: 'Vizualizare meniu',
    storeUrl: 'URL magazin',
    loading: 'Se încarcă previzualizarea…',
    noResults: 'Niciun produs selectat nu corespunde căutării.',
    acknowledgeHint: 'Verifică datele lipsă de mai sus și bifează confirmarea pentru a activa importul.',
    apiUnavailable: 'API-ul de import meniu nu este disponibil pe acest server. Actualizează API-ul și rulează migrarea.',
    accessDenied: 'Contul tău nu are permisiunea de a importa meniuri pentru această companie.',
    timedOut: 'Cererea de import a expirat. Verifică istoricul importurilor înainte de a reîncerca.',
    title: 'Importă meniul de pe platformă',
    back: 'Înapoi',
    intro: 'Introdu URL-ul unui magazin Glovo, Wolt sau Bolt. Verifică meniul înainte de a-l adăuga în locație. Produsele existente rămân neschimbate.',
    preview: 'Încarcă previzualizarea',
    processing: 'Se procesează meniul… Te rugăm să păstrezi pagina deschisă.',
    done: 'Import finalizat',
    products: 'produse',
    categories: 'Categorii',
    gaps: 'Date lipsă și avertismente',
    search: 'Caută produse și opțiuni',
    image: 'URL imagine (câte unul pe rând)',
    name: 'Denumire',
    price: 'Preț de bază',
    description: 'Descriere',
    available: 'Disponibil',
    tax: 'TVA din locație',
    unknown: 'Necunoscut / nefurnizat',
    mode: 'Mod de selecție',
    single: 'Selecție unică',
    multiple: 'Selecție multiplă',
    counter: 'Cantități repetate',
    groupMin: 'Minim în grup',
    groupMax: 'Maxim în grup',
    eachMin: 'Minim per valoare',
    eachMax: 'Maxim per valoare',
    default: 'Selectat implicit',
    source: 'Detalii originale din sursă',
    reviewFee: 'Verifică și introdu această taxă separată ca garanție înainte de confirmare.',
    addDeposit: 'Adaugă garanție SGR atașată',
    acknowledge: 'Am verificat datele lipsă, asocierile TVA/POS și limitările de export.',
    skipImages: 'Permite importul fără imaginile care nu pot fi descărcate.',
    save: 'Salvează previzualizarea',
    confirm: 'Confirmă și adaugă elemente noi',
    cancel: 'Anulează importul',
    history: 'Istoric importuri de pe platforme',
    requestFailed: 'Cererea a eșuat. Verifică accesul sau reîncarcă previzualizarea dacă a fost editată de alt utilizator.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/platformMenuImport.js